module.exports = __webpack_public_path__ + "img/hotels-4.76299761.png";